import React, { Component } from "react";
import Fab from "@material-ui/core/Fab";
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";

class FabExterno extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, icon, onClick } = this.props;

    return (
      <div className="text-center m-4">
        <Fab
          style={{ height: "85px", width: "85px" }}
          color="primary"
          size="large"
          onClick={onClick}
        >
          <Icon style={{ fontSize: "3em" }} className={icon} />
        </Fab>
        <div className="mt-3">
          <Typography
            variant="h5"
            style={{ color: "#3f51b5", fontSize: "20px", fontWeight: "500" }}
          >
            {title}
          </Typography>
        </div>
      </div>
    );
  }
}

export default FabExterno;
